// Import Core
import React, { useState, useContext, useEffect } from "react";
import { Link } from "gatsby";
// Import Libraries
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from "styled-components";
import Slider from "react-slick";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { PortableText } from "@portabletext/react";
// Import Components
import { Button } from "../../ui/Button";
import SocialPopup from "../../ui/SocialPopup";
import HotelCTAGroup from "../../ui/HotelCTAGroup";
import Modal from "../../ui/Modal";
import PortableTextComponent from "../../ui/PortableTextComponent";
import Lightbox from "../../ui/Lightbox";
// Import Styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Impoort Icons
import { FaTag, FaShareSquare, FaImages, FaInfoCircle } from "react-icons/fa";
// Import Assets
import generalPlaceholderImage from "../../../assets/images/placeholder-images/general.png";
// Import Utils
import { displayLocation } from "../../../utils/displayLocation";
import useModal from "../../../utils/useModal";
import useLightbox from "../../../utils/useLightbox";
import { getSlug } from "../../../utils/getSlug";

/* Slick Slider settings */
const settings = {
  dots: true,
  indicators: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
      },
    },
  ],
};
const offerSettings = {
  dots: false,
  arrows: false,
  indicators: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipeToSlide: true,
  autoplay: true,
  autoplaySpeed: 6500,
  // fade: true,
  infinite: true,
};
// const badgeSettings = {
//   dots: false,
//   arrows: false,
//   indicators: false,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   swipeToSlide: true,
//   autoplay: true,
//   autoplaySpeed: 5000,
//   // fade: true,
//   infinite: badgeArray.length>3 ? true : false,
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: {
//         slidesToShow: 2,
//       },
//     },
//     // {
//     // 	breakpoint: 768,
//     // 	settings: {
//     // 		slidesToShow: 3,
//     // 	},
//     // },
//   ],
// };

/* Styled Components */
const HeroStyle = styled.section`
  background: var(--white);
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100vw;
  height: 100%;
  overflow: hidden;
  @media (max-width: 992px) {
    min-height: fit-content;
  }

  .hero_main {
    display: flex;
    width: 100%;
    @media (max-width: 768px) {
      flex-direction: column-reverse;
    }
    .hero_single-image-container {
      max-width: 60vw;
      min-width: 200px;
      width: 60vw;
      margin-left: auto;
      height: 540px;
      overflow: hidden;
      &.unpaid {
        width: 25vw;
        height: auto;
        min-height: unset !important;
        @media (max-width: 992px) {
          margin-top: 45px;
        }
        @media (max-width: 768px) {
          width: 80%;
          margin: 0 auto;
        }
        .gatsby-image-wrapper {
          height: auto;
        }
      }
      @media (max-width: 992px) {
        min-height: 350px;
        /* height: auto; */
      }
      @media (max-width: 768px) {
        width: 100%;
        max-width: unset;
        height: 184px;
      }
      .gatsby-image-wrapper {
        height: 100%;
        width: 100%;
      }
      .hero_placeholder {
        height: inherit;
      }
    }
    .in-guide-not-paid {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
  }

  .hero_slider-wrapper {
    position: relative;
    width: 60vw;
    margin-left: auto;
    height: 540px;
    overflow: hidden;
    @media (max-width: 992px) {
      min-height: 350px;
      height: auto;
    }
    @media (max-width: 768px) {
      width: 100%;
      height: 184px;
    }

    .gatsby-image-wrapper {
      height: 100%;
      width: 100%;
    }

    .slick-slider {
      max-width: 60vw;
      margin-left: auto;
      @media (max-width: 992px) {
        max-width: unset;
      }

      img {
        /* Add a background while slider is loading */
        background-image: url(${generalPlaceholderImage});
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        background-color: var(--primary);
        opacity: 0.5;
      }

      .slick-list {
        .slick-track {
          .slick-slide {
            div {
              .caption {
                position: absolute;
                bottom: 10px;
                right: 10px;
                color: var(--white);
              }
              .hero_slide-container {
                height: 100%;
                margin: auto;
                object-fit: cover;
              }

              .hero_overlay {
                content: "";
                background: rgba(0, 0, 0, 0.4);
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                position: absolute;
                z-index: 2;
              }
            }

            &.slick-current {
              margin-right: -80px;
              @media (max-width: 768px) {
                margin-right: -60px;
              }

              div {
                .hero_slide-container {
                  width: calc(100% - 90px);
                  margin-left: 0;
                  @media (max-width: 768px) {
                    width: calc(100% - 70px);
                  }
                }
                .hero_overlay {
                  display: none;
                }
              }
            }
          }
        }
      }

      .slick-arrow {
        position: absolute;
        left: 50px;
        right: 50px;
        width: 67px;
        height: 67px;
        left: unset;
        top: unset;
        &.slick-prev {
          bottom: 100px;
        }
        &.slick-next {
          bottom: 18px;
        }
      }

      .slick-dots {
        text-align: right;
        right: 140px;
        bottom: 22px;
        display: none;
        @media (max-width: 768px) {
          text-align: left;
          right: unset;
          left: 22px;
          bottom: 8px;
        }
      }
    }
    .lightbox-btn {
      position: absolute;
      right: 8px;
      bottom: 8px;
      display: none;
      @media (max-width: 768px) {
        display: block;
      }
    }
  }

  .hotel_cta-group {
    min-width: 184px;
    max-width: calc(60vw - 16px);
    width: calc(60vw - 16px);
    margin-left: auto;
    padding: 16px 16px 40px 16px;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
    &.unpaid {
      max-width: calc(25vw - 16px);
      width: calc(25vw - 16px);

      @media (max-width: 768px) {
        width: calc(100% - 32px);
        max-width: unset;
      }
    }
    @media (max-width: 1200px) {
      width: calc(60vw - 28px);
    }
    @media (max-width: 992px) {
      width: calc(60vw - 26px);
    }
    @media (max-width: 768px) {
      max-width: unset;
      width: calc(100% - 32px);
      flex-direction: column;
    }
  }
`;

const HeroContentStyles = styled.div`
  width: fit-content;
  max-width: calc(40vw - 144px);
  padding: 40px 72px 18px 40px;
  @media (max-width: 1200px) {
    max-width: calc(40vw - 60px);
    padding: 40px 30px 18px;
  }

  @media (max-width: 768px) {
    max-width: calc(100% - 48px);
    padding: 40px 24px 18px;
    width: 100%;
  }

  .hero_subheading-wrapper {
    /* color: var(--primary-500); */
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    width: inherit;
    .hero_subheading {
      margin-bottom: 18px;
    }
    .hero_share-socials {
      padding-left: 12px;
      margin-bottom: 16px;
      &:hover {
        color: var(--primary-400);
      }
    }
  }

  .hero_heading {
    margin-bottom: 16px;
  }

  .tooltip {
    margin-bottom: 8px;
  }

  .hero_location {
    margin-bottom: 24px;
    text-transform: capitalize;
    color: var(--neutral-700);
  }
  .hero_content {
    margin-bottom: 24px;
    font-size: 20px;
  }
  .hero_special-offer-tag {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    svg {
      min-width: 30px;
      margin-right: 8px;
      color: var(--neutral-400);
    }
  }

  .hero_awards-images,
  .hero_special-offers {
    display: flex;
    list-style-type: none;
    gap: 24px;
    color: unset;

    /* ! FIX: TAKE OUT GLOBAL SLIDER SETTINGS! */
    .slick-slider {
      max-width: 400px;
      margin-left: 0;
      @media (max-width: 768px) {
        max-width: unset;
      }
      .slick-list {
        .slick-track {
          .slick-slide {
            height: unset !important;
            div {
              li {
                /* height: 100px; */
                height: auto;
                max-height: 120px;
                width: 100px;
                .gatsby-image-wrapper {
                  /* height: 100px; */
                  width: 100px;
                  object-fit: contain;
                }
              }
            }
          }
        }
      }
    }
  }
`;

/* Components */
const HeroIntro = ({ hotel, intlHotel, shortlistedHotelInfo }) => {
  const [isModalOpenShareSocial, toggleShareSocial] = useModal();
  const [isModalOpenShortlist, toggleShortlist] = useModal();

  return (
    <>
      {/* <div className='hero_subheading-wrapper'>
				<h5 className='hero_subheading'>Good Hotel Guide Selection</h5>
				<FaShareSquare
					className='hero_share-socials'
					onClick={toggleShareSocial}
				/>
				<Modal
					isModalOpen={isModalOpenShareSocial}
					hide={toggleShareSocial}
					content={<SocialPopup data={hotel} />}
				/>
			</div> */}

      {/* Shortlist will display only on paid hotels */}
      {hotel.displayOptions?.shortlist && hotel.displayOptions?.paid && (
        <div className="tooltip">
          <p className="small">Shortlist</p>
          <FaInfoCircle className="link" onClick={toggleShortlist} />
          <Modal
            isModalOpen={isModalOpenShortlist}
            hide={toggleShortlist}
            content={<p>{shortlistedHotelInfo}</p>}
          />
        </div>
      )}
      {hotel.name && (
        <div className="hero_subheading-wrapper">
          <h2 className="hero_heading">{hotel.name}</h2>
          <FaShareSquare
            className="hero_share-socials"
            onClick={toggleShareSocial}
          />
          <Modal
            isModalOpen={isModalOpenShareSocial}
            hide={toggleShareSocial}
            content={<SocialPopup data={hotel} />}
          />
        </div>
      )}

      {(hotel.addressGroup?.town || hotel.addressGroup?.county) && (
        <p className="hero_location">
          {displayLocation(
            hotel.addressGroup.town,
            hotel.addressGroup.county,
            hotel.addressGroup.country
          )}
        </p>
      )}
    </>
  );
};

const EditorsChoiceBadges = ({ editorsChoiceBadges }) => {
  const badgeArray = [];
  // If there is no year then it is one award & comes first in slider
  editorsChoiceBadges.forEach((page) => {
    const badgeSlug = getSlug(page);
    badgeArray.push({
      year: page.awardYear ? page.awardYear.value : 0,
      title: page.title,
      // asset: badge.editorsChoiceImage.editorsChoiceImgs.asset,
      asset: page.editorsChoiceImage.imageItem.content.asset,
      slug: badgeSlug,
    })
  })

  // sort by year descending
  badgeArray.sort((a, b) => b.year - a.year);
  
  const badgeSettings = {
    dots: false,
    arrows: false,
    indicators: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 5000,
    // fade: true,
    infinite: badgeArray.length>3 ? true : false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      // {
      // 	breakpoint: 768,
      // 	settings: {
      // 		slidesToShow: 3,
      // 	},
      // },
    ],
  };
  return (
    <Slider {...badgeSettings}>
      {badgeArray.map((badge) => (
        <li key={badge.title}>
          <Link to={badge.slug}>
            <GatsbyImage image={getImage(badge.asset)} alt={badge.title} />
          </Link>
        </li>
      ))}
    </Slider>
  );
};

const DisplayPaidOrStubContent = ({
  hotel,
  intlHotel,
  // lightboxPhotoIndex,
  // setLightboxPhotoIndex,
  isLightboxOpen,
  setIsLightboxOpen,
  specialOffers,
  specialOfferEnabled,
  shortlistedHotelInfo,
  editorsChoiceBadges,
  placeholderImage,
  inGuideNotPaidContent,
}) => {
  const hasPaid = hotel.displayOptions?.paid;
  const inGuide = hotel.displayOptions?.inGuide;

  const heroImagesLightbox = hotel.reviewTextAndMedia?.images;
  let hotelImg =
    hotel.reviewTextAndMedia?.homepageFeaturedImage &&
    hotel.reviewTextAndMedia?.homepageFeaturedImage?.asset
      ? hotel.reviewTextAndMedia?.homepageFeaturedImage?.asset
      : placeholderImage.asset;
  // get image asset from array and limit to 15 images per page
  let images = heroImagesLightbox
    ?.filter((img) => {
      return img.asset;
    })
    .slice(0, 15);
  
  if (hasPaid || intlHotel) {
    return (
      <div className="hero_main">
        <HeroContentStyles>
          <HeroIntro
            hotel={hotel}
            intlHotel={intlHotel}
            shortlistedHotelInfo={shortlistedHotelInfo}
          />

          {hotel.reviewTextAndMedia?.summaryContent && (
            <PortableText
              value={hotel.reviewTextAndMedia?.summaryContent}
              components={PortableTextComponent}
            />
          )}

          {specialOfferEnabled === true && (
            // <div className='hero_special-offers'>
            <AnchorLink
              to="#anchor_special-offers"
              className="hero_special-offers"
            >
              <Slider {...offerSettings}>
                {specialOffers.map((offer, index) => {
                  if (offer.enabled) {
                    return (
                      <h4 key={index} className="hero_special-offer-tag">
                        <FaTag />
                        {offer.title}
                      </h4>
                    );
                  } else return null;
                })}
              </Slider>
            </AnchorLink>
            // </div>
          )}

          {editorsChoiceBadges && (
            <div className="hero_awards-images">
              <EditorsChoiceBadges editorsChoiceBadges={editorsChoiceBadges} />
            </div>
          )}
        </HeroContentStyles>

        <div className="hero_slider-wrapper">
          {(images.length > 0 && (
            <Slider {...settings}>
              {images.map((each, index) => {
                if (each.asset) {
                  return (
                    <div key={index}>
                      <GatsbyImage
                        image={getImage(each.asset)}
                        alt={hotel.name}
                        className="hero_slide-container"
                      />
                      <div className="hero_overlay"></div>
                    </div>
                  );
                } else return null;
              })}
            </Slider>
          )) || <GatsbyImage image={getImage(hotelImg)} alt={hotel.name} />}

          <Button
            className="lightbox-btn"
            onClick={() => setIsLightboxOpen(true)}
          >
            <FaImages />
          </Button>

          <Lightbox
            images={images}
            isLightboxOpen={isLightboxOpen}
            setIsLightboxOpen={setIsLightboxOpen}
            hotelName={hotel.name}
          />
        </div>
      </div>
    );
  } else {
    // -> UNPAID
    return (
      <div className="hero_main">
        <HeroContentStyles>
          <HeroIntro hotel={hotel} />
          {/* If hotel is not paid but in the guide we have a different paragraph that comes from a siteSettings field */}
          {(inGuide && (
            <div className="in-guide-not-paid">
              <PortableText
                value={inGuideNotPaidContent}
                components={PortableTextComponent}
              />
            </div>
          )) || <p>This hotel is not currently in the Good Hotel Guide</p>}
        </HeroContentStyles>

        {/* If no homepageFeaturedImage revert to first image in gallery */}
        <div
          className={`hero_single-image-container ${
            inGuideNotPaidContent ? "unpaid" : ""
          }`}
        >
          {(hotel.reviewTextAndMedia?.homepageFeaturedImage &&
            hotel.reviewTextAndMedia?.homepageFeaturedImage?.asset && (
              <GatsbyImage
                image={getImage(
                  hotel.reviewTextAndMedia?.homepageFeaturedImage?.asset
                )}
                alt={hotel.name}
              />
            )) || (
            <GatsbyImage
              image={getImage(placeholderImage.asset)}
              alt={hotel.name}
            />
          )}

          <div className="hero_overlay"></div>
        </div>
      </div>
    );
  }
};

/* Render Component */
const HotelHero = ({
  data,
  intlHotel,
  specialOffers,
  specialOfferEnabled,
  shortlistedHotelInfo,
  editorsChoiceBadges,
  placeholderImage,
  inGuideNotPaidContent,
}) => {
  const hotel = data;

  // console.log('🅰️ 🅰️ 🅰️🅰️🅰️', editorsChoiceBadges);
  // const [lightboxPhotoIndex, setLightboxPhotoIndex] = useState(0);
  // const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [isLightboxOpen, setIsLightboxOpen] = useLightbox();

  // const [documentReady, setDocumentReady] = useState(false)
  // useEffect(() => {
  // 	console.log('lets re-render')
  // 	setDocumentReady(true)
  // }, [])

  return (
    <HeroStyle>
      <DisplayPaidOrStubContent
        hotel={hotel}
        intlHotel={intlHotel}
        // lightboxPhotoIndex={lightboxPhotoIndex}
        // setLightboxPhotoIndex={setLightboxPhotoIndex}
        isLightboxOpen={isLightboxOpen}
        setIsLightboxOpen={setIsLightboxOpen}
        specialOffers={specialOffers}
        specialOfferEnabled={specialOfferEnabled}
        shortlistedHotelInfo={shortlistedHotelInfo}
        editorsChoiceBadges={editorsChoiceBadges}
        placeholderImage={placeholderImage}
        inGuideNotPaidContent={inGuideNotPaidContent}
      />
      <HotelCTAGroup
        website={hotel.contactGroup?.websiteUrl}
        bookingUrl={hotel.contactGroup?.bookingUrl}
        bookNowUrl={hotel.contactGroup?.bookNowUrl}
        displayEmail={hotel.contactGroup?.displayEmail}
        email={hotel.contactGroup?.contactEmailAddress}
        telephone={hotel.contactGroup?.telephone}
        hasPaid={hotel.displayOptions?.paid}
        hotelName={hotel.name}
        slug={hotel.slug.current}
      />
    </HeroStyle>
  );
};

export default HotelHero;
